import { Contentful } from 'api/contentful/api'
import { Block } from 'components/Block'
import { Button } from 'components/button/Button'
import {
  SFutureMessageHeroContent,
  SFutureMessageHeroContentBox,
  SFutureMessageHeroContentWrapper,
  SFutureMessageHeroGallery,
} from './FutureMessageHero.styled'
import { Icon } from 'components/icon'
import { Text, Title, Title_h1_default } from 'components/Typography'
import { VideoCarousel } from 'components/videoCarousel/VideoCarousel'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { Await } from 'utils/types'

export function FutureMessageHero(props: {
  title: string
  desc: string
  futureMessageSetup?: Await<Contentful<'getFutureMessageSetup'>>
  className?: string
  onAction?: () => void
  buttonText: string
}) {
  const images = useContentfulImages()

  return (
    <Block className={props.className}>
      <SFutureMessageHeroContentWrapper>
        <SFutureMessageHeroContent>
          <SFutureMessageHeroContentBox>
            <Title variant={Title_h1_default} css={{ marginBottom: '1.5rem' }}>
              {props.title}
            </Title>

            <Text css={{ marginBottom: '1.6875rem' }}>{props.desc}</Text>

            <Button
              type="button"
              block={[true, false]}
              size="large"
              tone="accent"
              onClick={props.onAction}
              leftIcon={<Icon name="Send" />}
            >
              {props.buttonText}
            </Button>
          </SFutureMessageHeroContentBox>
        </SFutureMessageHeroContent>

        <SFutureMessageHeroGallery>
          <VideoCarousel disableAudio items={[{ video: images.future_message_hero_video }]} />
        </SFutureMessageHeroGallery>
      </SFutureMessageHeroContentWrapper>
    </Block>
  )
}
